import { render, staticRenderFns } from "./DanhSachGroupTheoNguoiDung.vue?vue&type=template&id=911d7fe8&"
import script from "./DanhSachGroupTheoNguoiDung.vue?vue&type=script&lang=js&"
export * from "./DanhSachGroupTheoNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports